import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { theme } from "antd";
import { COLOR_PRIMARY_SOFT_BG } from "../../../style/antdTheme.js";
const InfoCard = ({ variant = "soft-trust", icon, heading, leftBorderColor, children })=>{
    const { token } = theme.useToken();
    const background = variant === "primary-soft" ? COLOR_PRIMARY_SOFT_BG : variant === "bordered-info" ? token.colorBgContainer : token.colorBgLayout;
    const style = {
        background
    };
    if (variant === "bordered-info") {
        style.border = `1px solid ${token.colorPrimaryBorder}`;
    }
    if (leftBorderColor) {
        style.borderLeft = `4px solid ${leftBorderColor}`;
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: `rc-account-v2-info-card rc-account-v2-info-card--${variant}`,
        style: style,
        children: [
            (icon || heading) && /*#__PURE__*/ _jsxs("div", {
                className: "rc-account-v2-info-card__head",
                children: [
                    icon,
                    heading && /*#__PURE__*/ _jsx("div", {
                        className: "rc-account-v2-info-card__heading",
                        style: {
                            color: token.colorTextHeading
                        },
                        children: heading
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "rc-account-v2-info-card__body",
                style: {
                    color: token.colorText
                },
                children: children
            })
        ]
    });
};
export { InfoCard };
